/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CheckVerificationCodeResponseDtoBase
 * auto generated base class for the model CheckVerificationCodeResponseDtoModel.
 */
export const CheckVerificationCodeResponseDtoModelBase = ModelBase
  .named('CheckVerificationCodeResponseDto')
  .props({
    __typename: types.optional(types.literal("CheckVerificationCodeResponseDto"), "CheckVerificationCodeResponseDto"),
    isValid: types.union(types.undefined, types.boolean),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CheckVerificationCodeResponseDtoModelSelector extends QueryBuilder {
  get isValid() { return this.__attr(`isValid`) }
}
export function selectFromCheckVerificationCodeResponseDto() {
  return new CheckVerificationCodeResponseDtoModelSelector()
}

export const checkVerificationCodeResponseDtoModelPrimitives = selectFromCheckVerificationCodeResponseDto().isValid
